import { BellIcon } from '@synoptic/ui-kit/icons/react/bell.tsx';
import { CandlestickChartIcon } from '@synoptic/ui-kit/icons/react/candlestick-chart.tsx';
import { DataTransferBothIcon as SourcesIcon } from '@synoptic/ui-kit/icons/react/data-transfer-both.tsx';
import { LearningIcon } from '@synoptic/ui-kit/icons/react/learning.tsx';
import { ListIcon } from '@synoptic/ui-kit/icons/react/list.tsx';
import { PackagesIcon } from '@synoptic/ui-kit/icons/react/packages.tsx';
import { SearchIcon } from '@synoptic/ui-kit/icons/react/search.tsx';
import { SettingsIcon } from '@synoptic/ui-kit/icons/react/settings.tsx';
import { ShareAndroidIcon } from '@synoptic/ui-kit/icons/react/share-android.tsx';
import { ViewGridIcon } from '@synoptic/ui-kit/icons/react/view-grid.js';
import { Fragment } from 'react';
import { BetaTag } from '@/components/beta-tag/beta-tag.tsx';
import { adminPaths, paths } from '@/routes-utils/paths.ts';
import { MarketplaceSubMenu } from '@/routes/_app/sidebar/menu/menu-action/marketplace-sub-menu.tsx';
import { EnterpriseMenuAction } from './menu-action/enterprise-menu-action.tsx';
import { GuestAuthMenuAction } from './menu-action/guest-auth-menu-action.tsx';
import { HomeMenuAction } from './menu-action/home-menu-action.tsx';
import { MenuActionLink } from './menu-action/menu-action-link.tsx';
import { NotificationsMenuAction } from './menu-action/notifications-menu-action.tsx';
import { ReportMenuAction } from './menu-action/report-menu-action.tsx';
import { StreamDeckSubMenu } from './menu-action/stream-deck-sub-menu.tsx';
import { TerminalSubMenu } from './menu-action/terminal-sub-menu.tsx';
import { adminAction, toolsMenuItem } from './menu.css.ts';

export const menuActions = {
  Home: <HomeMenuAction />,
  Marketplace: <MarketplaceSubMenu />,
  Streams: (
    <MenuActionLink
      icon={<ShareAndroidIcon />}
      to={paths.streams}
      label={'Data streams'}
    />
  ),
  CustomStreams: (
    <MenuActionLink
      icon={<ListIcon />}
      to={paths.customStreams}
      label={'Custom streams'}
    />
  ),
  StreamPackages: (
    <MenuActionLink
      icon={<PackagesIcon />}
      to={paths.streamPackages}
      label={'Stream packages'}
    />
  ),
  Notifications: (
    <NotificationsMenuAction
      icon={<BellIcon />}
      to={paths.notifications}
      label={'Notifications'}
    />
  ),
  Tools: (
    <MenuActionLink icon={<ViewGridIcon />} label={'Tools'} to={paths.tools} />
  ),

  GuestAuth: <GuestAuthMenuAction />,
  Search: (
    <MenuActionLink icon={<SearchIcon />} label={'Search'} to={paths.search} />
  ),
  More: <Fragment />,
  Report: <ReportMenuAction />,

  StreamDeck: <StreamDeckSubMenu />,
  Terminal: <TerminalSubMenu />,
  LearningCenter: (
    <MenuActionLink
      icon={<LearningIcon />}
      to={paths.learningCenter}
      label={
        <div className={toolsMenuItem}>
          Learning Center <BetaTag>New</BetaTag>
        </div>
      }
    />
  ),
  Enterprise: <EnterpriseMenuAction />,
  Charts: (
    <MenuActionLink
      icon={<CandlestickChartIcon />}
      to={paths.myCharts}
      label={'My Charts'}
    />
  ),
  Sources: (
    <MenuActionLink
      icon={<SourcesIcon />}
      to={adminPaths.sources}
      label={'My Sources'}
      className={adminAction}
    />
  ),
  Admin: (
    <MenuActionLink
      icon={<SettingsIcon />}
      to={adminPaths.dashboard}
      label={'Admin dashboard'}
      className={adminAction}
    />
  ),
};

export type MenuAction = (typeof menuActions)[keyof typeof menuActions];
